import {requestUrl, requestHeaders, requestOptions} from '../../graphQLClient.js'
import Vue from 'vue';
import moment from 'moment';
import {isExists, isEmptyObject} from '../../../helpers/check_variable_types.js';

const CSV = 'CSV';
const namespace = 'hourlyPartnersReport';

export default {
    getBaseData({commit, dispatch, state}){

        let requestQueryBody = {};
        requestQueryBody.operationName = null;

        requestQueryBody.query = `
                              {
                                sites: partnerHourlySites(
                                       orderBy: {sort: "name", direction: "ASC"} 
                                      ) {
                                  edges {
                                    node {
                                      id
                                      name
                                      domain
                                      marketId
                                      status
                                    }
                                  }
                                }
                                siteGroupTypes: partnerHourlySiteGroups(
                                       orderBy: {sort: "name", direction: "ASC"} 
                                      ) {
                                  edges {
                                    node {
                                      id
                                      name
                                    }
                                  }
                                }
                                partners: partnerHourlyPartners(
                                          orderBy: {sort: "company", direction: "ASC"} 
                                        ) {
                                  edges {
                                    node {
                                      id
                                      company
                                      code
                                      type
                                      parentId
                                      status
                                      partners {
                                        id
                                      }
                                    }
                                  }
                                }
                                sources: partnerHourlySources(
                                          orderBy: {sort: "company", direction: "ASC"} 
                                        ) {
                                  edges {
                                    node {
                                      id
                                      company
                                      code
                                      type
                                      parentId
                                      status
                                      partners {
                                        id
                                      }
                                    }
                                  }
                                }
                                devices: partnerHourlyDevices(
                                            orderBy: {sort: "id", direction: "ASC"} 
                                        ) {
                                  edges {
                                    node {
                                      id
                                      type
                                      name
                                      groupId
                                    }
                                  }
                                } 
                                markets: partnerHourlyMarkets(
                                            orderBy: {sort: "name", direction: "ASC"} 
                                        ) {
                                  edges {
                                    node {
                                      id
                                      name
                                      currency
                                      region
                                    }
                                  }
                                }
                                networks: partnerHourlyNetworks(
                                            orderBy: {sort: "name", direction: "ASC"} 
                                        ) {
                                  edges {
                                    node {
                                      id
                                      name
                                    }
                                  }
                                }
                              }
                             `;

        requestQueryBody.variables = null;

        let options = Object.assign({
            body: JSON.stringify(requestQueryBody),
            headers: requestHeaders
        }, requestOptions);

        return fetch(requestUrl, options).then(function(response){
            return response.json();
        }).then(function(data){
            return data.data;
        });
    },

    getSummaryDataFromAPI({dispatch, state}, filtersData)
    {
        return new Promise(function (resolve, reject) {
            return resolve({});
        });
    },

    getReportDataFromAPI({dispatch, state}, filtersData)
    {
        let columnsData = filtersData.columns;
        let sortingData = filtersData.sorting;
        let filtersList = filtersData.reportFilters;
        let paginationData = filtersData.paginationData;

        if (!filtersData.isBaseDataLoaded)
        {
            return new Promise(function (resolve, reject) {
                return resolve({});
            });
        }

        let requestQueryBody = {
            operationName: null,
            query: null,
            variables: {}
        };

        let filtersDeclaration = [];
        let filtersSchema = [];
        let columns = '';
        let columnsSummary = '';
        let limit = 10;

        filtersDeclaration.push('$orderByField: String!');
        filtersDeclaration.push('$orderByDirection: String!');
        filtersDeclaration.push('$paginationCursorBefore: String!');
        filtersDeclaration.push('$paginationCursorAfter: String!');

        requestQueryBody.variables.paginationCursorBefore = '';
        requestQueryBody.variables.paginationCursorAfter = '';
        requestQueryBody.variables.orderByField = '';
        requestQueryBody.variables.orderByDirection = '';

        requestQueryBody.variables.first = null;
        requestQueryBody.variables.last = null;
        filtersDeclaration.push('$first: Int');
        filtersDeclaration.push('$last: Int');

        let isUseDateRanges = (
            filtersList.filters.dateRange.startDateB !== null && filtersList.filters.dateRange.startDateB !== undefined &&
            filtersList.filters.dateRange.endDateB !== null && filtersList.filters.dateRange.endDateB !== undefined
        );

        if (filtersList.filters.format !== undefined) {
            limit = null;
            requestQueryBody.variables.reportFormat = filtersList.filters.format;
            filtersDeclaration.push('$reportFormat: ReportFormat');
            filtersSchema.push('reportFormat: $reportFormat');
        }

        if (filtersList.filters !== undefined)
        {
            if (columnsData !== undefined && columnsData.length) {
                let realColumns = columnsData.filter(column => column.virtualField !== true);
                realColumns = realColumns.filter(column => column.visible === true);

                let mainColumns = realColumns.filter(column => column.isMetricValue === false && column.isCompareColumn === false);
                let metricsColumns = realColumns.filter(column => column.isMetricValue === true || column.isCompareColumn === true);
                let metricsColumnsForSummary = realColumns.filter(column => column.isMetricValue === true);
                let columnsForSummary = realColumns.filter(column => column.isMetricValue === false);


                if (isUseDateRanges) {
                    metricsColumns.push({field: 'dateRange'});
                    metricsColumnsForSummary.push({field: 'dateRange'});
                }

                columns = mainColumns.map(column => column.field);
                metricsColumns = metricsColumns.map(column => column.field);
                metricsColumnsForSummary = metricsColumnsForSummary.map(column => column.field);
                columnsForSummary = columnsForSummary.map(column => column.field);

                if (metricsColumns.indexOf('week') !== -1 || metricsColumns.indexOf('quarter') !== -1) {
                    metricsColumns.push('year');
                    columnsForSummary.push('year');
                }

                columns = columns.join('\n');
                columns = columns + '\n' + 'metrics {' + metricsColumns.join('\n') + '\n}';

                columnsSummary = columnsForSummary.join('\n') + ' \n totals {' + metricsColumnsForSummary.join('\n') + '} \n averages {' + metricsColumnsForSummary.join('\n') + '} \n';

            }

            if (isUseDateRanges) {
                requestQueryBody.variables.dateRangesIn = [
                    [filtersList.filters.dateRange.startDate.format("YYYY-MM-DD"), filtersList.filters.dateRange.endDate.format("YYYY-MM-DD")],
                    [filtersList.filters.dateRange.startDateB.format("YYYY-MM-DD"), filtersList.filters.dateRange.endDateB.format("YYYY-MM-DD")]
                ];
                filtersDeclaration.push('$dateRangesIn: [[String!]]');
                filtersSchema.push('dateRangesIn: $dateRangesIn');
            }
            else if (filtersList.filters.dateRange.startDate !== null && filtersList.filters.dateRange.endDate !== null) {
                if(filtersList.filters.dateRange.excludedDates.length > 0) {
                    requestQueryBody.variables.dateIn = [];

                    let dateEnd = moment(filtersList.filters.dateRange.endDate);
                    let dateCurrent = moment(filtersList.filters.dateRange.startDate).add(-1, 'day');

                    do {
                        dateCurrent.add(1, 'day');
                        let formattedCurrentDate = dateCurrent.format("YYYY-MM-DD");
                        if (!filtersList.filters.dateRange.excludedDates.includes(formattedCurrentDate)) {
                            requestQueryBody.variables.dateIn.push(formattedCurrentDate);
                        }
                    } while (!dateEnd.isSame(dateCurrent, 'day'));

                    filtersDeclaration.push('$dateIn: [String!]');
                    filtersSchema.push('dateIn: $dateIn');
                } else {
                    requestQueryBody.variables.dateInRange = [filtersList.filters.dateRange.startDate.format("YYYY-MM-DD"), filtersList.filters.dateRange.endDate.format("YYYY-MM-DD")];
                    filtersDeclaration.push('$dateInRange: [String!]');
                    filtersSchema.push('dateInRange: $dateInRange');
                }
            }

            if (isExists(paginationData))
            {
                limit = paginationData.limit;
            }

            if (isExists(filtersList.filters.marketId) && filtersList.filters.marketId.length > 0) {
                requestQueryBody.variables.marketId = filtersList.filters.marketId;
                filtersDeclaration.push('$marketId: [JsInt!]');
                filtersSchema.push('marketIdIn: $marketId');
            }

            if (isExists(filtersList.filters.siteGroupTypeId) && filtersList.filters.siteGroupTypeId.length > 0) {
                requestQueryBody.variables.siteGroupIds = filtersList.filters.siteGroupTypeId;
                filtersDeclaration.push('$siteGroupIds: [JsInt!]');
                filtersSchema.push('siteGroupIdIn: $siteGroupIds');
            }

            if (isExists(filtersList.filters.networkId) && filtersList.filters.networkId.length > 0) {
                requestQueryBody.variables.networks = filtersList.filters.networkId;
                filtersDeclaration.push('$networks: [JsInt!]');
                filtersSchema.push('networkIdIn: $networks');
            }


            if (isExists(filtersList.filters.siteId) && filtersList.filters.siteId.length > 0) {
                requestQueryBody.variables.siteId = filtersList.filters.siteId;
                filtersDeclaration.push('$siteId: [JsInt!]');
                filtersSchema.push('siteIdIn: $siteId');
            }

            if (isExists(filtersList.filters.sourceId) && filtersList.filters.sourceId.length > 0) {
                requestQueryBody.variables.sourceId = filtersList.filters.sourceId;
                filtersDeclaration.push('$sourceId: [JsInt!]');
                filtersSchema.push('sourceIdIn: $sourceId');
            }

            if (isExists(filtersList.filters.partnerId) && filtersList.filters.partnerId.length > 0) {
                requestQueryBody.variables.partnerId = filtersList.filters.partnerId;
                filtersDeclaration.push('$partnerId: [JsInt!]');
                filtersSchema.push('partnerIdIn: $partnerId');
            }

            if (isExists(filtersList.filters.deviceId) && filtersList.filters.deviceId.length > 0) {
                requestQueryBody.variables.deviceIdIn = filtersList.filters.deviceId;
                filtersDeclaration.push('$deviceIdIn: [JsInt!]');
                filtersSchema.push('deviceIdIn: $deviceIdIn');
            }

            let advancedFilters = filtersData.reportFilters.advancedFilters;

            if(advancedFilters.campaignName && advancedFilters.campaignName.toString().length > 0
                && advancedFilters.adGroupName && advancedFilters.adGroupName.toString().length > 0)
            {
                requestQueryBody.variables.campaignAdgroupIn = [[
                    advancedFilters.campaignName, advancedFilters.adGroupName
                ]];
                filtersDeclaration.push('$campaignAdgroupIn: [[String]]');
                filtersSchema.push('campaignAdgroupIn: $campaignAdgroupIn');
            } else if( advancedFilters.campaignName && advancedFilters.campaignName.toString().length > 0 ) {
                requestQueryBody.variables.campaignIn = advancedFilters.campaignName;
                filtersDeclaration.push('$campaignIn: [String]');
                filtersSchema.push('campaignIn: $campaignIn');
            } else if( advancedFilters.adGroupName && advancedFilters.adGroupName.toString().length > 0 ) {
                requestQueryBody.variables.adgroupIn = advancedFilters.adGroupName;
                filtersDeclaration.push('$adgroupIn: [String]');
                filtersSchema.push('adgroupIn: $adgroupIn');
            }

            if( advancedFilters.hours ) {
                let min = parseInt(advancedFilters.hours.min);
                if(isNaN(min)) min = 0; if( min < 0 ) min = 0; if( min > 23 ) min = 23;

                let max = parseInt(advancedFilters.hours.max);
                if(isNaN(max)) max = 24; if( max < 1 ) max = 1; if( max > 24 ) max = 24;

                if( min != 0 || max != 24 ) {
                    let hourIn = [];
                    for(let i = min; i <= max; i++) {
                        hourIn.push(i);
                    }
                    requestQueryBody.variables.hourIn = hourIn;
                    filtersDeclaration.push('$hourIn: [JsInt!]');
                    filtersSchema.push('hourIn: $hourIn')
                }
            }

            // if (filtersList.advancedFilters !== undefined && filtersList.advancedFilters !== null) {
            //     if (
            //         filtersList.advancedFilters.hourStart !== undefined &&
            //         filtersList.advancedFilters.hourStart !== null &&
            //         filtersList.advancedFilters.hourStart.length > 0 &&
            //
            //         filtersList.advancedFilters.hourEnd !== undefined &&
            //         filtersList.advancedFilters.hourEnd !== null &&
            //         filtersList.advancedFilters.hourEnd.length > 0
            //     )
            //     {
            //         requestQueryBody.variables.hourInRange = [
            //             parseInt(filtersList.advancedFilters.hourStart),
            //             (parseInt(filtersList.advancedFilters.hourEnd) - 1),
            //         ];
            //         filtersDeclaration.push('$hourInRange: [JsInt!]');
            //         filtersSchema.push('hourInRange: $hourInRange');
            //     }
            // }


            if (sortingData.sortColumn !== null && sortingData.sortDirection !== null) {
                requestQueryBody.variables.orderByField = sortingData.sortColumn;
                requestQueryBody.variables.orderByDirection = sortingData.sortDirection;
            }

            if (paginationData !== null) {
                if (paginationData.direction == 'after') {
                    requestQueryBody.variables.paginationCursorAfter = paginationData.cursor;
                    requestQueryBody.variables.first = limit;
                }
                else if (paginationData.direction == 'before') {
                    requestQueryBody.variables.paginationCursorBefore = paginationData.cursor;
                    requestQueryBody.variables.last = limit;
                }
                else {
                    requestQueryBody.variables.first = limit;
                }
            }
        }

        var format = null;
        if (filtersList.filters !== undefined && filtersList.filters.format !== undefined) {
            format = filtersList.filters.format;
        }

        requestQueryBody.query = getReportRequestBody(columns, filtersDeclaration, filtersSchema, columnsSummary);

        let options = Object.assign({
            body: JSON.stringify(requestQueryBody),
            headers: requestHeaders
        }, requestOptions);

        return fetch(requestUrl, options).then(function (response) {
            if (format == CSV) {
                return response.blob();
            }
            else {
                return response.json();
            }
        }).then(function (data) {
            if (format == CSV) {
                return data;
            }
            else {
                return data.data;
            }
        }).catch(function (reason) {
            Vue.$log.warn(reason);

            Vue.prototype.$notification.setPosition('topRight')
                .setCloseStatus(true)
                .setCloseOnClick(true)
                .setCloseOnEscape(true)
                .setTimeout(false)
                .setSettings();

            Vue.prototype.$notification.showWarning('Warning!', 'Can not get data');

            return [];
        });
    },


    setSiteGroupTypesList({dispatch, state, commit}, value) {
        commit('setSiteGroupTypesList', value);
    },

    setFilteredSiteGroupTypesList({dispatch, state, commit}, value) {
        commit('setFilteredSiteGroupTypesList', value);
        dispatch('setFilteredSiteGroupTypesObjectList', value);
    },

    setFilteredSiteGroupTypesObjectList({dispatch, state, rootGetters, commit}, value) {

        if (typeof value  === 'undefined') {
            commit('setFilteredSiteGroupTypesObjectList', []);
            return;
        }

        let that = this;

        let objects = value.map(function(item){
            let object = that.getters[namespace + '/getSiteGroupTypesList'].filter(siteGroup => siteGroup.id == item);

            return object[0];
        });

        commit('setFilteredSiteGroupTypesObjectList', objects);
    },

    setNetworkList({dispatch, state, commit}, value) {
        commit('setNetworkList', value);
    },

    setFilteredNetworkList({dispatch, state, commit}, value) {
        commit('setFilteredNetworkList', value);
        dispatch('setFilteredNetworkObjectList', value);
    },

    setFilteredNetworkObjectList({dispatch, state, rootGetters, commit}, value) {

        if (typeof value  === 'undefined') {
            commit('setFilteredNetworkObjectList', []);
            return;
        }

        let that = this;

        let objects = value.map(function(item){
            let object = that.getters[namespace + '/getNetworkList'].filter(network => network.id == item);

            return object[0];
        });

        commit('setFilteredNetworkObjectList', objects);
    },
};

function getReportRequestBody(columns, filtersDeclaration, filters, summaryColumns) {
    let query;

    query = `query partnerHourlyReport(` + filtersDeclaration.join(', ') + `)
                  {
                      report: partnerHourlyReport(first: $first,
                        last: $last, 
                        filters: {
                            ` + filters.join(', ') + `
                        }, 
                        after: $paginationCursorAfter,
                        before: $paginationCursorBefore,
                        orderBy: [
                            {sort: $orderByField, direction: $orderByDirection}
                        ]) 
                        {
                          totalCount,
                          pageInfo {
                            hasNextPage
                            hasPreviousPage
                            startCursor
                            endCursor
                          }
                          edges {
                            cursor
                            node {
                            ` + columns + `
                            }
                          }
                        }
                      
                      summary: partnerHourlyReportSummary(first: $first,
                        last: $last, 
                        filters: {
                            ` + filters.join(', ') + `
                        })
                        {
                          edges {
                            cursor
                            node {
                            ` + summaryColumns + `
                            }
                          }
                        }
                  }
    `;

    return query;
}



// WEBPACK FOOTER //
// ./src/store/modules/hourlyPartnersReport/actions.js